<script lang="ts">
    import CheckBox from "../../leafElement/CheckBox.svelte";
    import RuleList from "./sub/RuleList.svelte";
    import Select from "../../leafElement/Select.svelte";
    import { getUid } from "../../script/common";
    import type {
        FTableData,
        FTableData_row,
        FTableHeadder,
        FTableHeadder_row,
    } from "../../script/types";
    import { evalFilter, evalSort } from "./sub/evalFilter";
    import TripleCounter from "../../mesurment/sub/TripleCounter.svelte";
    import PageIndex from "../../leafElement/PageIndex.svelte";
    import { MES_STAGE_MAP } from "../../script/enum";
    import Spinner from "../../leafElement/Spinner.svelte";

    const NULL_DISPL_VAL = "-";

    /* export interface FilterConfigDesc {
        type: "filter_and" | "filter_or" | "filter_val",
        sub: FilterConfigDesc[],
    } */

    export let headder: FTableHeadder | null = null;
    export let data: FTableData | null = null;
    export let refreshList: () => Promise<boolean> = null;
    let refreshInProgres = false;
    async function runRefreshList() {
        if (refreshList) {
            refreshInProgres = true;
            await refreshList();
            refreshInProgres = false;
        }
    }

    export function resetFilterAndSort() {
        filtrList = genFilterConfig();
        sortList = sortDefaultConfig;
    }

    export function resetChecks() {
        unselectAll(recordList);
        recordList = [...recordList];
    }

    export let selectedMask: boolean[] = [];
    export let selectedCount: number = 0;
    $: if (avalibleRecordList) {
        recomputeSelected();
    } else {
        selectedMask = [];
        selectedCount = 0;
    }

    function recomputeSelected() {
        selectedMask = new Array(avalibleRecordList.length).fill(false);
        selectedCount = 0;
        recordList
            .filter((row) => row._selected)
            .forEach((row) => {
                selectedMask[row._sequenceId] = true;
                selectedCount++;
            });
    }

    let headerList: FTableHeadder_row[] = [];
    let gridRowStyle = "";
    $: onNewHeader(headder);
    function onNewHeader(headerData: FTableHeadder) {
        if (headerData) {
            /* headder.data.forEach((val) => {
                if (!val.width) {
                    val.width = "1fr";
                }
                val.visible = true;
            }); */
            headerList = headerData.data.map((val) => {
                return {
                    name: val.name,
                    type: val.type,
                    width: val.width || "1fr",
                    visible: val.visible === undefined ? true : val.visible,
                };
            });
        } else {
            headerList = [];
        }
        recomputeWisibility();
    }
    function recomputeWisibility() {
        gridRowStyle = `--gridTempData: ${headerList
            .map((row) =>
                !row.visible
                    ? "0px"
                    : row.width === "autoSpace"
                    ? "auto"
                    : row.width
            )
            .join(" ")};`;

        /* minmax(auto, calc(auto + 1rem)) */
        // gridRowStyle = `--mainRows: ${headerList.length}`;
    }

    let recordList: FTableData_row[] = [];
    let avalibleRecordList: FTableData_row[] = [];
    $: {
        if (data) {
            data.data.forEach((row, j) => {
                row._selected = false;
                row._sequenceId = j;
                row._updateAvalibleRecords = (param) => {
                    avalibleRecordList[j]._selected = param.detail;
                };
                row.list.forEach((val, i) => {
                    if (i < headerList.length) {
                        val.type = headerList[i].type;
                    }
                });
            });
            avalibleRecordList = data.data;
        } else {
            avalibleRecordList = [];
        }
        reloadWiew();
    }

    /* ================ HEADER ============== */

    let headderFormList: {
        select: {
            name: string;
            value: {
                index: number;
                avalibleVal: any[];
                type: string;
            };
        }[];
    } = { select: [] };
    $: headderFormList =
        headerList && avalibleRecordList /* &&
        headerList.length === avalibleRecordList.length */
            ? genNewFormHeader(headerList, avalibleRecordList)
            : { select: [] };
    function genNewFormHeader(
        hList: FTableHeadder_row[],
        vList: FTableData_row[]
    ) {
        return {
            select: hList.map((block, i) => {
                return {
                    name: block.name,
                    value: {
                        index: i,
                        avalibleVal: vList.map((val) => val.list[i].val),
                        // avalibleVal: vList[i].list.map((val) => val.val),
                        type: block.type,
                    },
                };
            }),
        };
    }

    /* ================ FILTER ============== */

    export let defaultFilter = [];
    let filtrList = genFilterConfig();
    $: filtrList = genFilterConfig(defaultFilter);
    function genFilterConfig(config?: any[]) {
        // console.log('XX', (config && config.length !== 0) ? config[0].trg : '');
        return {
            type: "filter_and",
            isRoot: true,
            _uid: getUid(),
            sub: config ? config : [],
        };
    }
    $: reevalWiew(filtrList, sortList);

    const sortDefaultConfig = {
        type: "sort_list",
        isRoot: true,
        _uid: getUid(),
        sub: [
            /* {
                type: "sort_val",
                _uid: getUid(),
                trg: {
                    atr: 1,
                    operaion: "max",
                },
            }, */
        ],
    };
    let sortList = sortDefaultConfig;

    let allSelectVal = false;
    function allSelectTogle() {
        if (allSelectVal) {
            unselectAll(recordList);
        } else {
            selectAll(recordList);
        }
        updateView();
        // console.log("HH", avalibleRecordList);
    }

    function reloadWiew() {
        reevalWiew(filtrList, sortList);
    }
    function reevalWiew(filterList: any, sortList: any) {
        // console.log("GG", avalibleRecordList);
        unselectAll(avalibleRecordList);
        const newList = avalibleRecordList.filter((val) => {
            return evalFilter(filterList, val);
        });
        if (sortList.sub.length != 0) {
            newList.sort((a, b) => {
                const val = evalSort(sortList.sub, a, b);
                return val;
                /* for (let i = 0; i < sortList.sub.length; i++) {
                    console.log(sortList.sub, i, sortList.sub[i]);

                    const val = evalSort(sortList.sub[i], a, b);
                    if (val !== 0) return val;
                }
                return 0; */
            });
        }
        updatePageWiew(newList);
    }

    function unselectAll(valList: any[]) {
        for (let i = 0; i < valList.length; i++) {
            valList[i]._selected = false;
        }
        allSelectVal = false;
    }
    function selectAll(valList: any[]) {
        for (let i = 0; i < valList.length; i++) {
            valList[i]._selected = true;
        }
        allSelectVal = true;
    }
    function updateView() {
        recordList = [...recordList];
    }

    /* ================ PAGE ============== */
    let maxPage = 0;
    let recordPeerPage = 30;
    let curentPageIndex = 0;
    // max index (not gr)

    $: if (recordPeerPage) {
        reloadWiew();
    }
    const pageCountSelectAvalible = [
        /*  {
            name: "2",
            value: 2,
        }, */
        {
            name: "10",
            value: 10,
        },
        {
            name: "30",
            value: 30,
        },
        {
            name: "90",
            value: 90,
        },
        {
            name: "vše",
            value: -1,
        },
    ];

    function onPageChange(param: any) {
        curentPageIndex = param.detail;
        reloadWiew();
    }
    function updatePageWiew(newRecordList: FTableData_row[]) {
        maxPage =
            newRecordList.length === 0 || recordPeerPage === -1
                ? -1 // just disable paging
                : (newRecordList.length / recordPeerPage) % 1 === 0
                ? newRecordList.length / recordPeerPage - 1
                : Math.floor(newRecordList.length / recordPeerPage);
        if (curentPageIndex < 0 || maxPage < 0) {
            curentPageIndex = 0;
        } else if (curentPageIndex > maxPage) {
            curentPageIndex = maxPage;
        }
        if (recordPeerPage === -1) {
            curentPageIndex = 1;
            recordList = newRecordList;
        } else {
            const start = curentPageIndex * recordPeerPage;
            const end = (curentPageIndex + 1) * recordPeerPage;
            recordList = newRecordList.slice(start, end);
        }
        updateView();
        /* console.log(
            "[INFO - FTable pagegin update]",
            curentPageIndex,
            maxPage,
            recordPeerPage,
            newRecordList.length
        ); */
    }

    /* ================ TIME ============== */
    function getTimeAs_DateFormite(date: Date) {
        if (!date || isNaN(date.getTime())) return NULL_DISPL_VAL;
        return `${date.getDate().toString().padStart(2, " ")}.${(
            date.getMonth() + 1
        )
            .toString()
            .padStart(2, " ")} / ${date.getFullYear().toString().slice(-2)}`;
    }
    function getTimeAs_TimeFormite(date: Date) {
        if (!date || isNaN(date.getTime())) return NULL_DISPL_VAL;
        return `${date.getHours()}:${date.getMinutes()}`;
    }
    function getTimeAs_TimeLongFormite(date: Date) {
        if (!date || isNaN(date.getTime())) return NULL_DISPL_VAL;
        return `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
    }
</script>

<div class="root">
    <div class="wrapTop">
        <div class="borderBox">
            <div class="iconBase optionIconWrap">
                <p class="smallTitle">Filtr</p>
                <span class="material-icons"> filter_alt </span>
            </div>
            <RuleList
                bind:ruleList={filtrList}
                headerList={headderFormList}
                reloadData={reloadWiew}
            />
        </div>
        <div class="borderBox">
            <div class="iconBase optionIconWrap">
                <p class="smallTitle">Řazení</p>
                <span class="material-icons"> sort </span>
            </div>
            <RuleList
                bind:ruleList={sortList}
                headerList={headderFormList}
                reloadData={reloadWiew}
            />
        </div>
        <div class=" borderBox" style="grid-column: 1 / span 2;">
            <p class="smallTitle" style="text-align: center;">
                Zobrazené sloupce
            </p>
            <div class="visibleSwitchWrap">
                {#each headerList as headerListElement}
                    <div class="visibleSwitch">
                        <span>{headerListElement.name}</span>
                        <CheckBox
                            on:change={recomputeWisibility}
                            bind:enable={headerListElement.visible}
                        />
                    </div>
                {/each}
            </div>
        </div>
    </div>
    <div class="tableAll" style={gridRowStyle}>
        {#if headerList}
            <div class="tableCell">
                <span class="headerTitle"
                    >(
                    <strong>{recordList.length}</strong>
                    )</span
                >
            </div>

            {#each headerList as header}
                <dvi class="tableCell">
                    <span class="headerTitle">{header.name}</span>
                </dvi>
            {/each}
            <div style="place-self: center;" class="tableCell">
                <div
                    class="activeIcon inactiveIconPlus customIcon"
                    on:click={allSelectTogle}
                >
                    <span class="material-icons">
                        {allSelectVal ? "remove_done" : "done_all"}
                    </span>
                </div>
            </div>
        {/if}
        {#if recordList}
            {#each recordList as row, i}
                <!--                         <div class="recWrap">
                            <dvi class="record">
                                <div style="margin: 0 10px;">
                                    <CheckBox />
                                </div>
                            </dvi>
                        </div> -->
                <div class="rowSeqId tableCell">
                    <span>{i + 1}.</span>
                </div>
                {#each row.list as record, j}
                    <!-- <div class:recWrap_first={j === 0}
                         class:recWrap_even={(j+i) %1 === 1} class="recWrap"> -->
                    <div
                        class={`${j === 0 ? "recWrap_first" : ""} ${
                            (j + i) % 2 === 1 ? "recWrap_even" : ""
                        } recWrap tableCell`}
                    >
                        <div
                            style={j === 0 ? "width: 0;" : ""}
                            class:recWrap_even={(j + row.list.length) % 2 === 1}
                            class="recEnd"
                        >
                            <!-- TODO -->
                            <div class="recDividerFill" />
                            <div class="recDivider" />
                        </div>
                        <dvi class="record">
                            {#if record.type == "string"}
                                <span class="stringRec"
                                    >{record.val
                                        ? record.val
                                        : NULL_DISPL_VAL}</span
                                >
                            {:else if record.type == "number"}
                                <span class="stringRec"
                                    >{record.val === null ||
                                    record.val === undefined
                                        ? record.val.toString()
                                        : NULL_DISPL_VAL}</span
                                >
                            {:else if record.type == "title"}
                                <span
                                    class="stringRec"
                                    style="font-weight: 400;"
                                    >{record.val
                                        ? record.val
                                        : NULL_DISPL_VAL}</span
                                >
                            {:else if record.type == "time"}
                                {#if record.format == "date"}
                                    <span class="stringRec"
                                        >{getTimeAs_DateFormite(
                                            new Date(record.val)
                                        )}</span
                                    >
                                {:else if record.format == "time"}
                                    <span class="stringRec"
                                        >{getTimeAs_TimeFormite(
                                            new Date(record.val)
                                        )}</span
                                    >
                                {:else if record.format == "full"}
                                    <span class="stringRec"
                                        >{getTimeAs_TimeLongFormite(
                                            new Date(record.val)
                                        )}</span
                                    >
                                {:else}
                                    <span class="stringRec">{record.val}</span>
                                {/if}
                            {:else if record.type == "boolean"}
                                <span class="stringRec"
                                    >{record.val ? "Ano" : "Ne"}</span
                                >
                            {:else if record.type == "mesState"}
                                <span class="stringRec"
                                    >{MES_STAGE_MAP[record.val].text}</span
                                >
                            {:else if record.type == "tripleCounter"}
                                <TripleCounter valList={record.val} />
                            {:else}
                                <span>DATA NELZE ZOBRAZIT</span>
                            {/if}
                        </dvi>
                    </div>
                {/each}
                <div class="recWrap recWrap_last tableCell">
                    <div class="recEnd">
                        <!-- TODO -->
                        <div class="recDividerFill" />
                        <div class="recDivider" />
                    </div>
                    <dvi class="record">
                        <div style="margin: 0 10px;">
                            <CheckBox
                                on:change={recomputeSelected}
                                bind:enable={row._selected}
                            />
                        </div>
                    </dvi>
                </div>
            {/each}
        {:else}
            <div>
                <h2>Nic k zobrazení</h2>
            </div>
        {/if}
    </div>
    {#if recordList}
        <div class="footer">
            <div class="smallFooterActionList">
                {#if refreshList}
                    <div
                        class="activeIcon inactiveIconPlus customIcon"
                        disabled={refreshInProgres}
                        on:click={runRefreshList}
                    >
                        <span class="material-icons"> refresh </span>
                    </div>
                    {#if refreshInProgres}
                        <Spinner />
                    {/if}
                {/if}
            </div>
            <div class="pagerWrap">
                <div class="pagerWrapSelect">
                    <Select
                        name={"Záznamy na stránku"}
                        nullAvalible={false}
                        bind:userSelected={recordPeerPage}
                        optionsList={pageCountSelectAvalible}
                    />
                </div>
                <PageIndex
                    bind:index={curentPageIndex}
                    max={maxPage}
                    on:change={onPageChange}
                />
            </div>
        </div>
    {/if}
    <div class="action">
        <div class="borderBox">
            <p class="smallTitle">Akce:</p>
            <slot />
        </div>
    </div>
</div>

<style>
    .root {
        padding: 1rem;
        background: white;
        --mainRows: 4;
        /* --colorBack: #f0f0f0;
        --colorBackDarken: #e0e0e0; */
        --colorBack: rgb(247, 250, 252);
        --colorBackDarken: #e7f6fd;
        --headderTextColor: #333;
    }
    .wrapTop {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
    .visibleSwitchWrap {
        padding-top: 10px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }
    .visibleSwitch {
        display: flex;
        align-items: center;
        font-weight: 500;
        color: var(--back_D15);
        margin: 8px 1.2rem;
    }
    .visibleSwitch > span {
        margin-right: 5px;
    }

    .optionIconWrap {
        display: flex;
        align-items: center;
    }
    .optionIconWrap .material-icons {
        margin-left: 1rem;
    }
    .tableAll {
        margin: 0.5rem 1rem 0.5rem 0.5rem;
        display: grid;
        grid-row-gap: 3px;
        --gridTempData: repeat(var(--mainRows), 1fr);
        --gridTempFull: auto var(--gridTempData) auto;
        grid-template-columns: var(--gridTempFull);
    }
    .tableCell {
        overflow: hidden;
    }
    .headerTitle {
        /* padding: 12px 8px; */
        padding: 0.5rem 0.7rem;
        color: var(--headderTextColor);
    }
    .rowSeqId {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 3px;
        padding-right: 10px;
        color: var(--back_D15);
    }
    .rowSeqIdHeadder {
        /* color: var(--back_D2); */
        color: var(--headderTextColor);
        font-weight: 300;
        font-size: 1.2rem;
    }

    .recWrap {
        --colorBackThis: var(--colorBack);
        --colorBackThisReverse: var(--colorBackDarken);
        --bRadius: 0 0 0 0;
        display: grid;
        grid-template-columns: auto 1fr;
        /* grid-template-columns: 1fr auto; */
    }
    .record {
        padding: 5px 10px;
        flex-grow: 2;
        background: var(--colorBackThis);
        border-radius: var(--bRadius);
        display: flex;
        align-items: center;
    }

    .recWrap_even {
        --colorBackThis: var(--colorBackDarken);
        --colorBackThisReverse: var(--colorBack);
    }
    .recWrap_first {
        --bRadius: 0 0 0 15px;
    }
    .recWrap_last {
        --bRadius: 0 15px 0 0;
    }
    .recWrap_odd {
        --colorBackThis: var(--colorBack);
        --colorBackThisReverse: var(--colorBackDarken);
    }

    .stringRec {
        font-size: 0.95rem;
        font-weight: 300;
    }

    .recEnd {
        position: relative;
        height: 100%;
        /* width: 6px;  */
        width: 2px;
        background: var(--colorBackThisReverse);
    }
    .recDividerFill {
        position: absolute;
        right: 0;
        left: 0;
        top: 0;
        bottom: 0;
        background: var(--colorBackThis);
        clip-path: polygon(0 0, 100% 0, 20% 100%, 0% 100%);
        /* clip-path: polygon(0 0, 100% 0, 100% 7%, 7% 100%, 0 100%); */
        /* filter: drop-shadow(5px 5px 0 #000); */
    }
    .recDivider {
        position: absolute;
        right: 0;
        left: 0;
        top: 5px;
        bottom: 5px;
        background: var(--prim_D2);
        /* clip-path: polygon(0 0, 100% 0, 90% 10%, 90% 90%, 100% 100%, 0 100%, 10% 90%, 10% 10%); */
        clip-path: polygon(
            0 0,
            100% 0,
            85% 20%,
            85% 80%,
            100% 100%,
            0 100%,
            15% 80%,
            15% 20%
        );
        /* clip-path: polygon(80% 0, 100% 0, 20% 100%, 0% 100%); */
        /* clip-path: polygon(100% 0, 100% 0, 100% 7%, 7% 100%, 0 100%, 0 93%); */
    }
    .customIcon {
        margin: 5px;
        margin-right: 10px;
    }
    .customIcon > .material-icons {
        font-size: 1.6rem;
    }
    .action {
        margin-top: 1rem;
    }

    .footer {
        top: 3px;
        padding: 0 8px;
        display: grid;
        /* justify-items: start; */
        grid-template-columns: 1fr auto;
        align-items: flex-start;
    }
    .smallFooterActionList {
        grid-column: 1 / span 1;
        display: flex;
        align-items: center;
    }
    .pagerWrap {
        grid-column: 2 / span 1;
        display: flex;
        justify-content: flex-end;
        position: relative;
        align-items: center;
    }
    .pagerWrapSelect {
        padding-right: 1.5rem;
    }
    .pagerWrap > p {
        align-self: center;
        font-size: 1.5rem;
        color: var(--back_D2);
        padding: 0 5px;
    }
</style>
